import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, paymentMethodId) => {
    return await put(`/basket/${basketId}/payment-method/${paymentMethodId}`, []);
};
